<template>
    <cadastro-simples-list
        endpoint="tipo-documento-anexo"
        rota-base="/admin/tipo-documento-anexo"
        titulo="TIPOS DE DOCUMENTOS ANEXO"
        titulo-singular="Tipo de Documento Anexo"
        :colunas-extras='[
            { campo: "descricao", label: "Descrição", tipo: "string" }
        ]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
